export default "<p>lexus-seat-element works!</p>\n"